import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import API from "../lib/api";
import { Section, ArticleCard, Pillar } from "../components/Common";
import PractitionerRecommendations from "../components/PractitionerRecommendations";
import DeepContentBlocks from "../components/DeepContentBlocks";
import { STATIC_HUB_DEEP_CONTENT } from "../config/staticHubDeepContent";
import { Zap, Bed, Brain, ShieldCheck, Heart, Activity, Apple, Sparkles } from "lucide-react";

export default function MensWellnessPage() {
  const { t } = useTranslation();
  const [articles, setArticles] = useState([]);
  useEffect(() => {
    API.get("/content/articles?category=mens-wellness&limit=12").then(({ data }) => setArticles(data.items || []));
  }, []);
  const pillars = t("mens.pillars", { returnObjects: true });
  const icons = [Zap, Brain, Bed, Activity, ShieldCheck, Heart, Sparkles, Heart, Sparkles, Apple, Activity];
  const deep = STATIC_HUB_DEEP_CONTENT.mens;
  return (
    <div data-testid="page-mens">
      <section className="relative overflow-hidden hero-bg">
        <div className="app-container pt-16 pb-12 grid md:grid-cols-2 gap-8 items-center">
          <div>
            <div className="text-xs tracking-[0.32em] uppercase gold-text" data-testid="mens-eyebrow">{t("mens.eyebrow")}</div>
            <h1 className="font-display text-4xl md:text-6xl mt-3 leading-[1.05] max-w-[14ch]" data-testid="mens-title">{t("mens.title")}</h1>
            <p className="text-white/75 mt-5 max-w-[52ch] leading-relaxed body-copy">{t("mens.subtitle")}</p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link to="/dosha" className="btn-primary text-sm" data-testid="mens-cta-dosha">{t("mens.cta_dosha")}</Link>
              <Link to="/ask-donny" className="btn-secondary text-sm" data-testid="mens-cta-donny">{t("mens.cta_donny")}</Link>
            </div>
          </div>
          <div className="aspect-[4/5] rounded-2xl overflow-hidden border border-white/10 max-w-md md:ml-auto">
            <img src="https://images.unsplash.com/photo-1568602471122-7832951cc4c5?auto=format&fit=crop&w=900&q=85" alt={t("mens.image_alt")} className="w-full h-full object-cover" />
          </div>
        </div>
      </section>
      <Section eyebrow={t("mens.pillars_eyebrow")} title={t("mens.pillars_title")}>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3" data-testid="mens-pillars">
          {pillars.map((p, i) => <Pillar key={i} label={p} icon={icons[i % icons.length]} />)}
        </div>
      </Section>
      <Section eyebrow={t("mens.editorial_eyebrow")} title={t("mens.editorial_title")} subtitle={t("mens.editorial_subtitle")}>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="mens-articles">
          {articles.map((a) => <ArticleCard key={a.id} article={a} />)}
        </div>
      </Section>
      <DeepContentBlocks
        pageTitle={deep.pageTitle}
        editorial={deep.editorial}
        quotes={deep.quotes}
        products={deep.products}
        askDonnyPrompt={deep.askDonnyPrompt}
        testidPrefix="mens-deep"
      />
      <PractitionerRecommendations
        eyebrow={t("marketplace.find_pro_eyebrow")}
        title={t("mens.practitioners_title")}
        subtitle={t("mens.practitioners_subtitle")}
        topic="mens-wellness"
        limit={3}
        testid="mens-practitioner-recs"
      />
    </div>
  );
}
